import { Component, effect, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';
import { AppUpdateService, DataContext, NetworkStatusService } from '@services';
import { MbmBannerComponent } from '@components';

@Component({
  selector: 'app-root',
  imports: [IonApp, IonRouterOutlet, MbmBannerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly translate = inject(TranslateService);
  private readonly dataContext = inject(DataContext);
  protected readonly networkStatus = inject(NetworkStatusService);
  private readonly appUpdate = inject(AppUpdateService);

  constructor() {
    this.appUpdate.initialize();

    effect(() => {
      const user = this.dataContext.loggedInUser();
      if (user?.language) {
        this.translate.use(user.language);
      }
    });
  }
}
